module.exports = __webpack_public_path__ + "conheca/static/media/balao2.507f3622.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Desafios/balao2.png
// module id = 354
// module chunks = 37